<template>
  <div class="chart-container"
       :style="{ height }">
    <div class="chart-wrap"
         :style="{ maxWidth }">
      <div class="chart">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '250px',
    },
    maxWidth: {
      type: String,
      default: "100%"
    },
    padding: {
      type: String,
      default: null
    }
  },
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart {
  flex-grow: 1 !important;
}
</style>